import React from 'react';
import './ErrorBoundary.css';
import SvgComponent from '../SvgComponent';
type Props = { children?: React.ReactNode };
type State = { hasError: boolean };

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="permission_denied">
          <div className="denied__wrapper">
            <h1>404</h1>
            <h3>
              LOST IN <span>SPACE</span> MAGPIIE? Hmm, looks like that page
              doesn&apos;t exist.
            </h3>
            <SvgComponent />
            <a href="#">
              <button className="denied__link">Go Home</button>
            </a>
          </div>
        </div>
      );
    }
    return this.props.children as React.ReactNode;
  }
}
export default ErrorBoundary;
